module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAU1JREFUSInVlctxwkAQRF/LBEAIhOAQRAgOQFT5YkwUiCgo+YgCYR2BUyAEEkDtAyCEYLHkT7nok2pm1L09sx+4d+giUi5T+WHel8hyACCbLprx5Jy8mMvJui85gEwuk1MWkcWVxVyrwvGCDqg5lukxlFwUtSz2QjZdgEKzxYPjh6wUCN8mj+DSwS9jEM2Uxfzgqobl0LeFUYE9uVNQaAsjj1Qlo9jW7CRwkAmevIzPImXxQaVHMLIApy6LqMgNAY+whlq9raHRHjME8GSqoyOZ3HBVoPOQ63lYQ6ztKVO974VOe7+jA20QtFvUF/+4TWMzAJC38f/OEXVgeQMnouMMnOyerOq5LsxmwarGZLPQz0H2OvbV+BWiCDn8yQyc1gewKWDtFuD0p9d1O6R2gUx+SIV28ddwapE3T/WVJ3O/ivZF14leu8WtedwnPgF1s5PhroqA4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/14.png
// module id = 4R21
// module chunks = 1